// extracted by mini-css-extract-plugin
module.exports = {"clipped-content":"clipped-content_clipped-content__sesY_","clipped-content--mobile":"clipped-content_clipped-content--mobile__wwcvM","content":"clipped-content_content__yQnr5"};